import type { RouterConfig } from '@nuxt/schema'
import routes from '../router/routes'
// 기준 소스와 같이 SPA 화면 경로를 명시한다. 권한 meta는 이 목록에서 관리한다.
export default <RouterConfig>{ routes: () => routes, scrollBehavior: () => ({ top: 0 }) }
